if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    class CartDrawer extends SideDrawer {
      constructor() {
        super();
        this.moved = true;
      }
    
      open(triggeredBy) {
        super.open(triggeredBy);
        const cartDrawerDetails = this.querySelectorAll('[id^="Details-"] summary');
        [...cartDrawerDetails].forEach((summary) => this.setSummaryAccessibility(summary));
      }
    
      close() {
        super.close();
        const cartDrawerDetails = this.querySelectorAll('[id^="Details-"] summary');
        [...cartDrawerDetails].forEach((summary) => {
          summary.parentElement.removeAttribute('open');
          summary.setAttribute('aria-expanded', false);
        });
      }
    
      setSummaryAccessibility(summary) {
        if (summary.hasAttribute('role')) return;
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', 'false');
        if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
        summary.addEventListener('click', (event) => event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')));
        summary.parentElement.addEventListener('keyup', onKeyUpEscape);
      }
    }
  );
}